<template>
    <div :class="{ 'layout-header': true, 'is-active': !getMenuToggle }">
        <button class="btn btn-icon btn__sidebar__toggle" @click="doToggleMenu"><i class="icon icon-menu"></i></button>
        <nav class="navbar-nav ml-auto">
            <vc-service-account-bar></vc-service-account-bar>
        </nav>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    methods: {
        doToggleMenu() {
            this.$store.dispatch('changeMenuToggle', { menu_toggle: !this.getMenuToggle });
        },
    },
    computed: {
        ...mapGetters([
            'getMenuToggle',
        ]),
    },
};
</script>
